import FooterFr from 'components/FooterFr'
import MobileFooterFr from 'components/MobileFooterFr'
import MobileNavbarFr from 'components/MobileNavbarFr'
import NavbarFr from 'components/NavbarFr'
// import WorkshopVidsFr from 'components/Seminar/WorkshopVidsFr'
import React from 'react';
import SeminarAllFr from "components/Seminar/SeminarAllFr"
import { useSelector } from "react-redux";

function SeminarsFr() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbarFr />
      <SeminarAllFr />
      {/* <WorkshopVidsFr /> */}
      <MobileFooterFr />
      </>
    ) : (
      <>
      <NavbarFr />
      <SeminarAllFr />
      {/* <WorkshopVidsFr /> */}
      <FooterFr />
      </>
    )}
    </>
  )
}

export default SeminarsFr